// src/components/teaching/CoursesList.jsx
import React from 'react';

const CoursesList = () => {
  const courses = [
    {
      name: "Dependable Informatics Systems",
      code: "COURSE4453",
      level: "MSc",
      institution: "UPL/ISEL",
      department: "DEI",
      semester: "Fall 2026/2027",
      description: "Understand the various aspects involved in designing a reliable and resilient IT system."
    },
    
      {
        name: "Internet of Things",
        code: "COURSE4111",
        level: "MSc",
        institution: "UPL/ISEL",
        department: "DEI",
        semester: "Spring 2026/2027",
        description: "Brief description of the course content and objectives"
      },
      {
        name: "Scalable Data-Driven AI",
        code: "COURSE4509",
        level: "MSc",
        institution: "UPL/ISEL",
        department: "DEI",
        semester: "Spring 2026/2027",
        description: "Brief description of the course content and objectives"
      },
       {
        name: "Communication & Society",
        code: "COURSE4308",
        level: "MSc",
        institution: "UPL/ISEL",
        department: "DEI",
        semester: "Spring 2026/2027",
        description: "Brief description of the course content and objectives"
      },
      {
        name: "Information Systems",
        code: "COURSE4175",
        level: "BSc",
        institution: "UPL/ISEL",
        department: "DEI",
        semester: "Spring 2026/2027",
        description: "Brief description of the course content and objectives"
      },
    // Add more courses
  ];

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Teaching</h2>
      <div className="grid gap-6">
        {courses.map((course, index) => (
          <div key={index} className="border-l-4 border-indigo-500 pl-4">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {course.name} ({course.code})
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              {course.level} • {course.department} • {course.institution}
            </p>
            <p className="text-gray-500 dark:text-gray-400">
              {course.semester}
            </p>
            {/* <p className="text-gray-600 dark:text-gray-300 mt-2">
              {course.description}
            </p> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoursesList;